interface GetMarkedLocationMapboxStyleOptions {
    interaction: InteractionState;
    isEmbedded: boolean | undefined;
    preview: boolean | undefined;
    selections: SelectionState[];
}

export default function getStyle({
    interaction,
    isEmbedded,
    preview,
    selections,
}: GetMarkedLocationMapboxStyleOptions) {
    if (
        preview ||
        isEmbedded ||
        interaction.type !== 'normal' ||
        !interaction.markedLocation ||
        selections.length > 1
    )
        return;
    // Do not show marked location if the selection is a waypoint
    const selectedWaypoints = selections.filter((selection) => selection.type === 'waypoint');
    if (selectedWaypoints.length) return;

    const {markedLocation} = interaction;
    return {
        version: 8,
        metadata: {
            id: 'markedLocation',
        },
        sources: {
            source: {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: markedLocation.toArray(),
                    },
                },
            },
        },
        layers: [
            {
                type: 'symbol',
                source: 'source',
                minZoom: 3,
                layout: {
                    'icon-image': 'markedLocationIcon',
                    'icon-size': 0.9,
                    'icon-allow-overlap': true,
                    'icon-ignore-placement': true,
                },
            },
        ],
    };
}
